import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from '../../config/axios'
import { TeamMember, TeamMemberSyncResponse } from './types'

export const bulkSyncTeamMembers = createAsyncThunk<TeamMemberSyncResponse, File>(
  'teamMember/bulkSyncTeamMembers',
  async (file) => {
    try {
      const formData = new FormData()
      formData.append('file', file)

      const response = await axios.post('/teamMember/bulkSyncTeamMembers', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      return response.data
    } catch (error) {
      console.error('Error bulk syncing team members:', error)
      throw new Error('Failed to bulk sync team members')
    }
  },
)

export const fetchTeamMemberInfo = createAsyncThunk<TeamMember, Partial<TeamMember>>(
  'teamMember/getTeamMemberInfo',
  async (queryParams) => {
    try {
      const params = new URLSearchParams()

      Object.entries(queryParams).forEach(([key, value]) => {
        if (value !== undefined) {
          params.append(key, value.toString())
        }
      })

      const response = await axios.get(`/teamMember/getTeamMember?${params.toString()}`)
      return response.data
    } catch (error) {
      console.error('Error fetching team member info:', error)
      throw new Error('Failed to fetch team member info')
    }
  },
)

export const fetchTeamMembers = createAsyncThunk('teamMember/fetchAllTeamMembers', async () => {
  try {
    const response = await axios.get('/teamMember/getAllTeamMember')
    return response.data
  } catch (error) {
    console.error('Error fetching team members:', error)
    throw new Error('Failed to fetch team members')
  }
})

export const fetchTeamMemberPoints = createAsyncThunk(
  'teamMember/getPoints',
  async (payload: any, { rejectWithValue }) => {
    const { teamMemberEmail, teamMemberWorkdayId } = payload

    const queryParams = new URLSearchParams()
    if (teamMemberEmail) queryParams.append('teamMemberEmail', teamMemberEmail)
    if (teamMemberWorkdayId) queryParams.append('teamMemberWorkdayId', teamMemberWorkdayId)

    try {
      return axios.get(`/teamMember/getPoints?${queryParams}`).then((response) => response.data)
    } catch (error: any) {
      console.error('Error fetching team member points:', error)
      return rejectWithValue(error.response?.data || error.message)
    }
  },
)
